document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.bs-carousel-wrap').forEach(function (wrap) {
    var track = wrap.querySelector('[data-carousel-track]');
    var prevBtn = wrap.querySelector('[data-carousel-prev]');
    var nextBtn = wrap.querySelector('[data-carousel-next]');

    if (!track) return;

    function scrollAmount() {
      var card = track.querySelector('.bs-card');
      if (!card) return 220;
      var style = window.getComputedStyle(track);
      var gap = parseInt(style.gap || '18', 10);
      return card.offsetWidth + gap;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
      });
    }
  });
});
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-wishlist-btn]').forEach(function (btn) {
    var productId = btn.getAttribute('data-product-id');
    var wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');

    if (wishlist.indexOf(productId) !== -1) {
      btn.classList.add('is-active');
    }

    btn.addEventListener('click', function () {
      wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
      var idx = wishlist.indexOf(productId);

      if (idx === -1) {
        wishlist.push(productId);
        btn.classList.add('is-active');
      } else {
        wishlist.splice(idx, 1);
        btn.classList.remove('is-active');
      }
      localStorage.setItem('wishlist', JSON.stringify(wishlist));
    });
  });
});